import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClickButton, IconButton } from "../../base/buttons";
import { translate } from "../../base/i18n";
import { getLocalParticipantId, ROLE } from "../../base/participants";
import { setGroupList } from "../action";

function AddGroupButton({ t, list, popup = false, handlerClose }) {
    const dispatch = useDispatch();
    const user_uuid = useSelector(state => getLocalParticipantId(state));
    const nameRef = useRef();
    const onClick = () => {
        saveGroup();
    }

    const onKeyDown = e => {
        if (e.keyCode != 13) return true;

        saveGroup();
        return false;
    }

    const chkDupGName = name => {
        if (list.find(item => item.name === name)) return true;
        return false;
    }

    const saveGroup = async () => {
        if (nameRef.current) {
            const name = nameRef.current.value;
            if (!name) {
                alert(t("group.requiredGroup"));
                return;
            } else if (chkDupGName(name)) {
                alert(t("group.alreadyGroup"));
                return;
            }

            const data = { members: [{ id: user_uuid, role_name: ROLE.HOST }] };
            const { complete, message } = await APP.API.createGroup(name, data);
            
            if (complete) {
                const list = {
                    uuid: message,
                    name,
                    participant: new Array()
                };
    
                dispatch(setGroupList([list]));
    
                nameRef.current.value = "";
                if (popup) handlerClose();
            } else alert(t(message));            
        }
    }

    return (
        <div className="section section_add">
            <input ref={nameRef} type="text" placeholder={t("group.requiredGroup")} onKeyDown={onKeyDown} />
            { popup ? <ClickButton text={t("group.add")} size={20} onClick={onClick} /> : <IconButton size={24} mode={"fillAdd"} onClick={onClick} /> }
        </div>
    )
}

export default translate(AddGroupButton);